<template>
  <div class="updater">
    <div class="content">
      <SpinText class="spinner" /> 
      <p>{{ $t("atualiza")}}</p>
    </div>
  </div>
</template>

<script>
import SpinText from '@/components/spinLoaderText.vue';

export default {
  name: 'UpdaterLoader',
  components: {
    SpinText
  }
}
</script>

<style scoped>
.updater {
  display: flex;
  flex-direction: column;
  z-index:99998;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(245,245,245,0.85);
  align-items: center;
}

.content{
  padding-top: 250px;
}

p{
  font-family: "Montserrat Light";
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  .updater {
    top: 54px;
  }
}
</style>